"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OneLinkOnboardingDelegate = void 0;
class OneLinkOnboardingDelegate {
    constructor(oneLink) {
        this._oneLink = oneLink;
    }
    addGidInfo(gid) {
        this._oneLink.params.ampExtra.setExtra('source_group_id', gid);
        this._oneLink.searchParams.set('af_ad', `?gid=${gid}`);
    }
    addOnBoardingDialogInfo(value) {
        this._oneLink.params.deepLinkValue = value;
    }
}
exports.OneLinkOnboardingDelegate = OneLinkOnboardingDelegate;
